import React from "react";
import MuiDialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/system";

const StyledDialogContent = styled(DialogContent)(({ height, width }) => ({
  padding:"1rem",
  margin: "5px",
}));

const Dialog = ({ open, handleClose, title, children, height, width }) => {
  return (
    <MuiDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="dialog-title"
      PaperProps={{
        sx: {
          width: width ?? "400px",
          maxWidth: "none", 
          height: height === "auto" ? "auto" : height ?? "210px",
          maxHeight: height === "auto" ? "90vh" : undefined,
          overflow: height === "auto" ? "auto" : "hidden",
          borderRadius: "8px",
        },
      }}
    >
      <DialogTitle id="dialog-title" sx={{ padding: "12px" }}>
        {title}
      </DialogTitle>
      <StyledDialogContent height={height} width={width}>
        {children}
      </StyledDialogContent>
    </MuiDialog>
  );
};

export default Dialog;
